import { defineColumn, type StrictColumnDef } from '../../../../components/tanstack-table/column';
import { buyupTotalCost } from '../../../../data/order-item';
import { preciseCurrencyFormatter } from '../../../../helpers/format-currency';
import type { ProductOrderItem } from '../data/product-order-item';

export const extendedBuyupCostColumn: StrictColumnDef<ProductOrderItem> =
  defineColumn<ProductOrderItem>({
    id: 'Extended Cost',
    minWidth: 80,
    accessorFn: (orderItem) => preciseCurrencyFormatter(buyupTotalCost(orderItem)),
    toCSV: (orderItem) => ({
      'Extended Cost': buyupTotalCost(orderItem).toFixed(2),
    }),
  });
